export const INTERNAL_KEY = 'internal'

export const INTERNAL_VALUE = '1'

export const INTERNAL = `${INTERNAL_KEY}=${INTERNAL_VALUE}`

// 1 year
export const INTERNAL_MAX_AGE = 60 * 60 * 24 * 365

export const INTERNAL_PATH = '/'
